import { useLanguage } from "@/contexts/LanguageContext";
import { resolveImprintContact } from "@shared/imprint";

const labels = {
  en: { provider: "Provider information", represented: "Represented by", registration: "Registration", taxId: "Tax ID", contact: "Contact", email: "Email", phone: "Telephone" },
  de: { provider: "Anbieterinformationen", represented: "Vertreten durch", registration: "Registrierung", taxId: "Steuer-ID", contact: "Kontakt", email: "E-Mail", phone: "Telefon" },
  tr: { provider: "Hizmet sağlayıcı bilgileri", represented: "Temsil eden", registration: "Sicil kaydı", taxId: "Vergi numarası", contact: "İletişim", email: "E-posta", phone: "Telefon" },
};

export function ImprintDetails({ details }: { details: unknown }) {
  const { locale } = useLanguage();
  const text = labels[locale];
  const contact = resolveImprintContact(details);
  const hasContact = Boolean(contact.email || contact.phone);
  return <div className="space-y-10" data-testid="imprint-details">
    <section aria-labelledby="imprint-provider"><h2 id="imprint-provider" className="font-display text-3xl font-semibold">{text.provider}</h2>
      <address className="mt-6 border-l-2 border-[#A98950] pl-6 not-italic">
        <p className="font-sans text-lg font-semibold text-[#171717]">{contact.companyName}</p>
        {contact.owner && <p className="mt-3 text-sm leading-7 text-[#57534D]">{text.represented}: {contact.owner}</p>}
        {contact.address && <p className="mt-4 whitespace-pre-line text-base leading-8 text-[#57534D]">{contact.address}</p>}
      </address>
      {(contact.registration || contact.taxId) && <div className="mt-7 space-y-2 text-sm leading-7 text-[#57534D]">
        {contact.registration && <p>{text.registration}: {contact.registration}</p>}
        {contact.taxId && <p>{text.taxId}: {contact.taxId}</p>}
      </div>}
    </section>
    {hasContact && <section data-testid="imprint-contact" aria-labelledby="imprint-contact-title"><h2 id="imprint-contact-title" className="font-display text-3xl font-semibold">{text.contact}</h2><div className="mt-5 space-y-3 text-sm leading-7 text-[#57534D]">
      {contact.email && <p>{text.email}: <a className="break-all underline underline-offset-4" href={`mailto:${contact.email}`}>{contact.email}</a></p>}
      {contact.phone && <p>{text.phone}: <a className="underline underline-offset-4" href={`tel:${contact.phone.replace(/[^+\d]/g, "")}`}>{contact.phone}</a></p>}
    </div></section>}
  </div>;
}
